import { createAction, props } from '@ngrx/store';

export const setEditMode = createAction(
  '[Third Party Stepper] Set Edit Mode',
  props<{ data: boolean }>()
);

export const setNewLOA = createAction(
  '[Third Party Stepper] Set New LOA',
  props<{ data: boolean }>()
);

export const setStepIndex = createAction(
  '[Third Party Stepper] Set Step Index',
  props<{ data: number }>()
);

export const enableDone = createAction(
  '[Third Party Stepper] Enable Done',
  props<{ data: boolean }>()
);

export const clear = createAction(
  '[Third Party Stepper] Clear'
);
